'use client'

export function FplComingSoonPage() {
  return <p className="text-sm text-white/40">Coming soon.</p>
}
